export const SET_DASHBOARDS = 'SET_DASHBOARDS';
export const SET_USER_POINTS = 'SET_USER_POINTS';
export const SET_TEAM_POINTS = 'SET_TEAM_POINTS';
export const SET_REGISTERED_USERS = 'SET_REGISTERED_USERS';